import { render, staticRenderFns } from "./RkSwitch.vue?vue&type=template&id=5534f20a&scoped=true"
import script from "./RkSwitch.vue?vue&type=script&lang=js"
export * from "./RkSwitch.vue?vue&type=script&lang=js"
import style0 from "./RkSwitch.vue?vue&type=style&index=0&id=5534f20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534f20a",
  null
  
)

export default component.exports